<div class="col-12 flex flex-column" style="height: 78vh">
  <div class="flex flex-column flex-grow-1">
    <form [formGroup]="formatFormGroup" #documentFormDirective="ngForm">
      <div class="p-fluid formgrid grid pb-2">
        <div class="col-12 md:col-12 lg:col-12">
          <label for="formatName" style="font-weight: bold;">
            {{'CreatePalletStock.FormatNameLabel' | translate}} *
          </label>
          <input id="formatName" formControlName="formatName" type="text"
            pInputText placeholder="Format Name" class="custom-input" />
          <small *ngIf="submitFormatName  && formatFormGroup.controls['formatName'].invalid" class="p-error">{{getErrorMessage(formatFormGroup, 'formatName')}}</small>
        </div>
      </div>
    </form>

    <form [formGroup]="columnsFormGroup" *ngIf="file">
      <div class="p-fluid formgrid grid formgroup-inline align-items-end pb-2">
        <div class="col-12 md:col-4">
          <label for="fileColumn" style="font-weight: bold;">
            {{'CreatePalletStock.FileColumn' | translate}} *
          </label>
          <p-dropdown
            id="fileColumn"
            formControlName="fileColumn"
            appendTo="body"
            [options]="fileColumnOptions"
            [filter]="true"
            optionLabel="label"
            filterBy="label"
            optionValue="value"
            [showClear]="false"
            [autoDisplayFirst]="false"
            class="custom-dropdown"/>
        </div>

        <div class="col-12 md:col-4">
          <label for="stockColumn" style="font-weight: bold;">
            {{'CreatePalletStock.FruztyColumn' | translate}} *
          </label>
          <p-dropdown
            id="stockColumn"
            formControlName="stockColumn"
            appendTo="body"
            [options]="stockColumnOptions"
            [filter]="true"
            optionLabel="columnName"
            filterBy="columnName"
            optionValue="columnKey"
            [showClear]="false"
            [autoDisplayFirst]="false"
            class="custom-dropdown">
              <ng-template pTemplate="selectedItem" let-stockColumn>
                <div *ngIf="stockColumn">
                  {{ stockColumn | stockColumnDesc }}
                </div>
              </ng-template>
              <ng-template let-stockColumn pTemplate="item">
                      <div>{{stockColumn | stockColumnDesc}}</div>
              </ng-template>
          </p-dropdown>
        </div>

        <div class="col-12 md:col-2">
          <label for="columnOrder" style="font-weight: bold;">
            {{'CreatePalletStock.ColumnOrder' | translate}}
          </label>
          <p-inputNumber
            id="columnOrder"
            formControlName="columnOrder"
            placeholder="{{'CreatePalletStock.ColumnOrder' | translate}}"
            class="custom-input-number"
          />
        </div>

        <div class="col-12 md:col-2 mt-2 md:mt-0">
          <p-button
            label="{{'CreatePalletStock.AddNewColumn' | translate}}"
            (onClick)="onAddColumn()"
            class="custom-text-button add-button"
            [loading]="loading"
            styleClass="p-button-sm">
          </p-button>
        </div>
      </div>
    </form>

    <div class="flex justify-content-end gap-2 mb-1 col-12" >
        <div
          *ngIf="!file"
          class="button-div"
          (click)="addEmptyColumn()"
        >
          <span class="material-symbols-outlined info-icon success-color-icon">
            add
          </span>
          <span class="info-text-primary">
            {{'CreatePalletStock.AddEmptyBtn' | translate}}
          </span>
        </div>

        <div
          class="button-div"
          (click)="onVisiblePreview()"
        >
          <span class="material-symbols-outlined info-icon secondary-color-icon">
            visibility
          </span>
          <span class="info-text-secondary">
            {{'CreatePalletStock.PreviewButton' | translate}}
        </span>
        </div>

        <div
          *ngIf="!file"
          class="button-div"
          (click)="visibleRemoveColumn()"
        >
          <span [ngClass]="deletedColumns.length == 0 ? 'disabled-color-icon' : 'secondary-color-icon' " class="material-symbols-outlined info-icon">
            replay
          </span>
          <span [ngClass]="deletedColumns.length == 0 ? 'info-text-disabled' : 'info-text-secondary' ">
            {{'CreatePalletStock.ReturnRow' | translate}}
          </span>
        </div>
    </div>

    <div *ngIf="!file || formatId" class="grid">
      <div class="col-12 stock-columns-table">
        <p-table
          [value]="stockColumns"
          [scrollable]="true"
          scrollHeight="flex"
          (onRowReorder)="updateColumnOrder($event)"
          class="custom-table">
          <ng-template  pTemplate="header">
            <tr>
              <th>
                <div class="flex justify-content-center">
                  {{'CreatePalletStock.OrderColumn' | translate}}
                </div>
              </th>
              <th>
                <div class="flex justify-content-center">
                  {{'CreatePalletStock.FruztyColumn' | translate}}
                </div>
              </th>
              <th>
                <div class="flex justify-content-center">
                  {{'CreatePalletStock.ActionsColumn' | translate}}
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template  pTemplate="body" let-column let-index="rowIndex">
            <tr [pReorderableRow]="index">
              <td>
                <div class="flex justify-content-center">
                  {{ index }}
                </div>
              </td>
              <td>
                <div pReorderableRowHandle class="flex justify-content-center">
                    {{ column  | stockColumnDesc }}
                </div>
              </td>
              <td>
                <div class="flex justify-content-center">
                    <span class="material-symbols-outlined icon"
                    style="color: red;"
                    (click)="removeColumn(index, column.id)" pTooltip="{{'CreatePalletStock.RemoveButton' | translate}}">remove</span>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <div *ngIf="file && !formatId" class="grid">
      <div class="col-12 match-columns-table">
        <p-table
          [value]="fileStockMatchedColumns"
          [scrollable]="true"
          scrollHeight="flex"
          class="custom-table">
          <ng-template pTemplate="header">
            <tr>
              <th>
                <div class="flex justify-content-center">
                  {{'CreatePalletStock.OrderColumn' | translate}}
                </div>
              </th>
              <th>
                <div class="flex justify-content-center">
                  {{'CreatePalletStock.FileColumn' | translate}}
                </div>
              </th>
              <th style="min-width: 300px;">
                <div class="flex justify-content-center">
                  {{'CreatePalletStock.FruztyColumn' | translate}}
                </div>
              </th>
              <th>
                <div class="flex justify-content-center">
                  {{'CreatePalletStock.ActionsColumn' | translate}}
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-column let-index="rowIndex">
            <tr [pReorderableRow]="index">
              <td>
                <div class="flex justify-content-center">
                  {{ index }}
                </div>
              </td>
              <td>
                <div pReorderableRowHandle class="flex justify-content-center">
                  {{ column.fileColumn }}
                </div>
              </td>
              <td>
                <div pReorderableRowHandle class="flex justify-content-center">
                    {{ column  | stockColumnDesc }}
                </div>
              </td>
              <td>
                <div class="flex justify-content-center">
                    <span class="material-symbols-outlined icon"
                    style="color: red;"
                    (click)="removeFromSelectedColumns(index)"
                    pTooltip="{{'CreatePalletStock.RemoveButton' | translate}}">remove</span>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="4">
                <div class="flex justify-content-center align-items-center">
                  <span>{{'CreatePalletStock.SelectColumnsToAdd' | translate}}</span>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

  <div class="flex justify-content-end align-content-end gap-2 mt-2 pb-3">
      <p-button
        label="{{'CreatePalletStock.CancelButtonLabel' | translate}}"
        (onClick)="onCancelCreateAction()"
        styleClass="p-button-outlined"
        class="custom-text-button form-button"></p-button>
      <p-button
        [label]="buttonAction"
        (onClick)="handleFormatPalletAction()"
        [loading]="loading"
        class="custom-text-button form-button"></p-button>
  </div>
</div>

<p-dialog header="{{'CreatePalletStock.RemoveRowTitle' | translate}}"
  [modal]="true"
  [draggable]="false"
  [resizable]="true"
  [(visible)]="visibleDeletedColumns"
  [style]="{'width': '50vw', 'height': 'auto', 'max-height': 'none', 'overflow': 'visible'}">
  <ng-template pTemplate="content">
    <p>{{'CreatePalletStock.AddRemoveRowsDescription' | translate}}</p>
    <p-table [value]="deletedColumns"
      [scrollable]="true"
      class="custom-table"
      scrollHeight="500px">
        <ng-template  pTemplate="header">
          <tr>
            <th>
              <div class="flex justify-content-center">
                {{'CreatePalletStock.FruztyColumn' | translate}}
              </div>
            </th>
            <th>
              <div class="flex justify-content-center">
                {{'CreatePalletStock.ActionsColumn' | translate}}
              </div>
            </th>
          </tr>
        </ng-template>
        <ng-template  pTemplate="body" let-column let-index="rowIndex">
          <tr>
            <td>
              <div class="flex justify-content-center">
                  {{ column  | stockColumnDesc }}
              </div>
            </td>
            <td>
              <div class="flex justify-content-center">
                  <span class="material-symbols-outlined icon"
                  style="color: red;"
                  (click)="AddRemoveColumn(index)"
                  pTooltip="{{'CreatePalletStock.RemoveButton' | translate}}">add
                </span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
  </ng-template>
</p-dialog>

<p-dialog
  header="{{'CreatePalletStock.PreviewTitle' | translate}}"
  [resizable]="false"
  [modal]="true"
  [draggable]="false"
  [(visible)]="visiblePreview"
  [style]="{width: '80vw', height: '90vh'}"
  class="preview-dialog pb-4"
>
  <div *ngIf="visiblePreview" class="h-full flex flex-column">
    <div class="col-12 flex-shrink-0">
      <span style="font-size: small;">{{"PalletStockPreview.Description" | translate}}</span>
    </div>
    <div class="flex-grow-1 overflow-hidden p-2">
      <app-pallet-stock-preview
        [columns]="file ? fileStockMatchedColumns : stockColumns"
        [file]="file"
        [loading]="loading"/>
    </div>
  </div>
  <ng-template pTemplate="footer"></ng-template>
</p-dialog>


